export var base = '/api/core';
export function clientViewsUrl(companyId) {
  return "".concat(base, "/v2/companies/").concat(companyId, "/client-views/search");
}
export function clientUrl(companyId, clientId) {
  return "".concat(base, "/v3/companies/").concat(companyId, "/clients/").concat(clientId);
}
export function contactUrl(companyId, contactId) {
  return "".concat(base, "/v7/companies/").concat(companyId, "/contacts/").concat(contactId);
}
export function contactImageUrl(companyId, contactId) {
  return "".concat(base, "/v1/companies/").concat(companyId, "/contacts/").concat(contactId, "/image");
}
export function clientFindOrCreateUrl() {
  return "".concat(base, "/v3/clients/find-or-create");
}
export function contactCreateUrl(companyId) {
  return "".concat(base, "/v7/companies/").concat(companyId, "/contacts");
}
export function getDefaultContact(companyId) {
  return "".concat(base, "/v7/companies/").concat(companyId, "/contacts/default");
}
export function contactRelationshipViewsUrl(companyId, contactId) {
  return "".concat(base, "/v1/companies/").concat(companyId, "/contacts/").concat(contactId, "/relationship-views/search");
}
export function contactViewsUrl(companyId) {
  return "".concat(base, "/v1/companies/").concat(companyId, "/contact-views/search");
}
export function companyMainUrl(companyId) {
  return "".concat(base, "/v3/companies/").concat(companyId, "/main");
}
export function registerUrl() {
  return '/api/profiles/v1/registration';
}
export function clientAccessUrl(companyId, contactId) {
  return "/api/security/v1/companies/".concat(companyId, "/contacts/").concat(contactId, "/client/access");
}
export function themeUrl(companyId) {
  return "/api/profiles/v1/themes?company=".concat(companyId);
}
